// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "material-icons/iconfont/material-icons.css";
import SweetModal from "sweet-modal-vue/src/plugin.js";
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";
import { VueSpinners } from "@saeris/vue-spinners";
import App from "./App";
import router from "./router";

import { store } from "./store/store";

import { utilsMixin } from "./mixins/utils";

/* Shared styles */
import "./styles/app.css";
import "./styles/layout.css";
import "./styles/colors.css";

/* Global Mixins */
Vue.mixin(utilsMixin); // helper functions mixin

/* Plugins */
Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: "#00a09e",
      success: "#66BD63",
      danger: "#FB3640",
      warning: "#EDAE49",
      dark: "#01212B"
    }
  }
});
Vue.use(SweetModal);
Vue.use(VueSpinners);

Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  store: store,
  router,
  components: {
    App
  },
  template: "<App/>"
});
